var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardSuspended = function SvgCardSuspended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.527 15.152-.74-.74V9.684h-4.728L9.732 7.357h7.055v-1.58a.25.25 0 0 0-.072-.184.25.25 0 0 0-.185-.072H7.896L6.812 4.437h9.718c.375 0 .692.13.952.389.259.26.388.576.388.951v8.487c0 .173-.026.334-.08.481-.052.148-.14.283-.263.407ZM8.418 9.684H3.787v4.58c0 .065.026.123.08.177.053.053.112.08.176.08h9.212L8.418 9.684Zm8.87 8.85-2.95-2.93H4.043c-.375 0-.692-.13-.951-.389a1.295 1.295 0 0 1-.389-.951V5.77c0-.375.128-.691.383-.948s.567-.386.936-.386h.681l1.209 1.209H4.043a.245.245 0 0 0-.176.08.245.245 0 0 0-.08.176v1.455H6.09L1.966 3.211l.766-.745 15.302 15.302-.746.766Z",
    fill: "#666"
  })));
};
export default SvgCardSuspended;